if (!customElements.get("td-collection-megamenu")) {
    class TdCollectionMegamenu extends HTMLElement {
        constructor() {
            super();
            this.triggers = this.querySelectorAll('.td-collections-mm__link');
            this.bannerImages = this.querySelectorAll('[data-banner-collection-images]');
        }
    
        connectedCallback() {
            setTimeout(() => {
                this.attachListeners();
            });
        }
        
        attachListeners() {
            this.triggers.forEach((trigger) => {
                trigger.addEventListener('mouseenter', () => {
                    this.toggleCollection(trigger)
                })
            })
        }

        toggleCollection(link) {
            this.triggers.forEach(trigger => trigger.classList.remove('active'));
            link.classList.add('active');
            const activeLink = link.textContent.trim();
            this.bannerImages.forEach((images) => {
                if (images.classList.contains('active')) {
                    images.classList.remove('active')
                }
            });

            let swatch = this.querySelector(`[data-banner-collection-images="${activeLink}"]`)
            if (swatch) {
                swatch.classList.add('active')
            }
        }
    }

    customElements.define("td-collection-megamenu", TdCollectionMegamenu);
}